"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDashboardContentAll = void 0;
exports.dashboardContentAllSetMock = dashboardContentAllSetMock;
exports.dashboardContentAll = dashboardContentAll;
exports.useQueryDashboardContentAll = useQueryDashboardContentAll;
exports.useInfiniteQueryDashboardContentAll = useInfiniteQueryDashboardContentAll;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function dashboardContentAllSetMock(mock) {
    setMock = mock;
}
async function dashboardContentAll(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/dashboard/content`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.equipmentType = params.equipmentType;
    queryParams.page = params.page;
    queryParams.perPage = params.perPage;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyDashboardContentAll = 'wolf-dashboard-service:dashboardContentAll:get';
function useQueryDashboardContentAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyDashboardContentAll, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryDashboardContentAll(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyDashboardContentAll, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = dashboardContentAll(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=dashboard-content-all.js.map